export const INITIAL_INPUTS = {
  starting_income: "",
  income_growth_rate: 0.04,
  rpi: 0.041,
  overpayment_type: "monthly",
  overpayment_amount: "",
  overpayment_lump_sum_whole_thing: false,
  annual_threshold_increase: 0.02,
};

export const MONTH_OPTIONS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];
